module.exports = __webpack_public_path__ + "img/5a.16297e87.png";